import { Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  selector: 'sbnb-vr-platform',
  template: `<sbnb-apps-detail-page
  vendorCode="vrplatform"
  name="VRPlatform"
  logoTile="/assets/images/apps/vrplatform.svg"
  builtBy="VRPlatform"
  builtByLink="https://www.vrplatform.app/"
  [categories]="['Accounting']"
  [permissions]="[
    AppPermission.propertyListingRead,
    AppPermission.reservationRead,
    AppPermission.financialsRead,
    AppPermission.calendarRead
  ]"
  email="nichole@vrplatform.app"
  [helpArticles]="[
        {
          id: '8198900',
          title:
            'How to integrate VRPlatform with Hospitable to Automate your Bookkeeping'
        }
      ]"
  >
  <ng-container description>
    <div class="space-y-4">
      <p>
        VRPlatform, the future in Trust Accounting for the short-term rental industry, streamlines the month-end process from revenue management to owner fees to owner statements and reporting:
      </p>
      <ul class="space-y-3 list-disc pl-5 leading-normal">
        <li>
          <strong>Easy Trust Accounting Compliance:</strong> Full functioning general ledger with multi-dimension tracking supports complete trust balance reconciliation and compliance requirements.
        </li>
        <li>
          <strong>Revenue Management:</strong> Automated guest revenue management, including daily pro-rata revenue recognition.
        </li>
        <li>
          <strong>Easily Reconcile Payouts & Banks:</strong> Built-in bank feeds and bank reconciliations with auto matching to Airbnb & Stripe payouts makes reconciling banks a breeze.
        </li>
        <li>
          <strong>Management Commissions and Fees:</strong> Full automation of simple or complex management commission formulas, booking fees and other per reservation, nightly, weekly or monthly owner deductions.
        </li>
        <li>
          <strong>Billable Expenses:</strong> Capture 100% of owner billable expenses with optional mark-ups by using bank feeds, syncs with your company accounting, CSV uploads or ops system integrations like Breezeway.
        </li>
        <li>
          <strong>Owner statements and dashboards:</strong> Impress owners with customizable owner statements, dashboards, KPI's, year-end summaries, 1099's and more published in a secure online portal.
        </li>
        <li>
          <strong>Property Management Statements:</strong> Have full insight into the management revenue earned during the month with our robust management income statements that can be synced with your company accounting software.
        </li>
        <li>
          <strong>ACH owner and vendor payments:</strong> Keep vendors and owners happy by quickly paying balances due with ACH transfers from your trust bank account.
        </li>
      </ul>

      <p><strong>Pricing</strong></p>

      <div class="space-y-3 pl-5">
        <div class="flex">
          <div class="w-64">First 10 Units (per month):</div><div>$100.00</div>
        </div>
        <div>Additional Units (each/month):</div>
        <div class="flex">
          <div class="w-64">Units 11-25:</div><div>$10.00</div>
        </div>
        <div class="flex">
          <div class="w-64">Units 26-50:</div><div>$9.00</div>
        </div>
        <div class="flex">
          <div class="w-64">Units 51-100:</div><div>$8.00</div>
        </div>
        <div class="flex">
          <div class="w-64">Units 101-250:</div><div>$7.00</div>
        </div>
        <div class="flex">
          <div class="w-64">Units 250+:</div><div>$6.00</div>
        </div>
      </div>
    </div>
  </ng-container>
</sbnb-apps-detail-page>`
})
export class VRPlatformComponent {
  public AppPermission = AppPermission;
} 